import React, { useEffect } from "react";
import Header from "~/assets/js/components/Header";
import {
    Banner,
    BottomBanner,
    FranchiseSection,
    Academy,
    BenefitsSection,
    BottomCards,
    RequirementsSection,
    Locations,
} from "./sections";
//import { viewPage } from "~/assets/js/Api/eventsApi";

const Franchise = () => {
    useEffect(() => {
        //viewPage("test");
    }, []);

    return (
        <main id="franchise">
            <Banner />
            <div className="container">
                <FranchiseSection />
            </div>
            <Academy />
            <BenefitsSection />
            <RequirementsSection />
            <Locations />
            <div className="container">
                <BottomCards />
            </div>
            <BottomBanner />
        </main>
    );
};

const FranchisePage = () => (
    <>
        <Header />
        <Franchise />
    </>
);

export default FranchisePage;
